module.exports = __webpack_public_path__ + "static/media/minus_icon.520273ed.svg";